<template>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="headline">Social Agent Overview</v-card-title>
        <v-card-text>
          <v-responsive aspect-ratio="16/9">
            <video controls width="100%">
              <source src="https://storage.googleapis.com/msgsndr/TGSfv8WEW3hdu8TmnEaj/media/6734d47985c88541fb0373bc.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </v-responsive>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="remindLater">Remind Later</v-btn>
          <v-btn color="primary" @click="closeDialog">I'm Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    name: 'VideoTour',
    data() {
      return {
        dialog: false,
      };
    },
    mounted() {
      if (!localStorage.getItem('tourClosed')) {
        this.dialog = true;
      }
    },
    methods: {
      remindLater() {
        this.dialog = false;
      },
      closeDialog() {
        localStorage.setItem('tourClosed', 'true');
        this.dialog = false;
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add any scoped styles here if necessary */
    video {
      width: 100% !important;
      height: auto !important;
      display: block;
    }
  </style>
  